import { Badge } from "@/components/ui/badge";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { Apple, MessageCircle, ShieldCheck, Slash } from "lucide-react";
import type { AdminUser } from "@/types";

export function RoleBadge({ role }: { role: string | null }) {
  if (!role) return null;
  if (role === "admin") {
    return (
      <Badge variant="info" className="gap-1">
        <ShieldCheck className="h-3 w-3" /> admin
      </Badge>
    );
  }
  return <Badge variant="outline">{role}</Badge>;
}

export function StatusPill({ user }: { user: AdminUser }) {
  if (user.banned) {
    return (
      <Badge variant="error" className="gap-1">
        <Slash className="h-3 w-3" /> banned
      </Badge>
    );
  }
  return <Badge variant="success">active</Badge>;
}

export function IntegrationIcons({ user }: { user: AdminUser }) {
  const ios = !!user.has_ios_device;
  const tg = !!user.has_telegram;
  const wa = !!user.has_whatsapp;
  return (
    <div className="flex items-center gap-1.5 text-muted-foreground">
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            role="img"
            aria-label={`iOS push ${ios ? "enabled" : "not registered"}`}
            className={ios ? "text-foreground" : "text-muted-foreground/30"}
          >
            <Apple className="h-3.5 w-3.5" aria-hidden="true" />
          </span>
        </TooltipTrigger>
        <TooltipContent>iOS push {ios ? "enabled" : "not registered"}</TooltipContent>
      </Tooltip>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            role="img"
            aria-label={`Telegram ${tg ? "linked" : "not linked"}`}
            className={tg ? "text-sky-300" : "text-muted-foreground/30"}
          >
            {/* telegram emoji-ish */}
            <svg aria-hidden="true" className="h-3.5 w-3.5" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <path d="M21.94 4.36 18.5 20.4c-.26 1.16-.94 1.45-1.9.9l-5.26-3.88-2.54 2.44c-.28.28-.52.52-1.06.52l.38-5.36 9.78-8.84c.42-.38-.1-.6-.66-.22L5.16 13.04l-5.22-1.64c-1.14-.36-1.16-1.14.24-1.7L20.5 2.66c.94-.36 1.78.22 1.44 1.7Z"/>
            </svg>
          </span>
        </TooltipTrigger>
        <TooltipContent>Telegram {tg ? "linked" : "not linked"}</TooltipContent>
      </Tooltip>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            role="img"
            aria-label={`WhatsApp ${wa ? "linked" : "not linked"}`}
            className={wa ? "text-emerald-300" : "text-muted-foreground/30"}
          >
            <MessageCircle className="h-3.5 w-3.5" aria-hidden="true" />
          </span>
        </TooltipTrigger>
        <TooltipContent>WhatsApp {wa ? "linked" : "not linked"}</TooltipContent>
      </Tooltip>
    </div>
  );
}
